import { memo } from "react";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { ACTIVATION_SETTINGS_TOOLTIP } from "app/pages/activation/components/Header/texts";

import { headerDataAutomation } from "../Header/dataAutomationKeys";

import * as SC from "./styles";

type SettingsIconSchema = { onClick(): void };

export const SettingsIcon = memo(({ onClick }: SettingsIconSchema) => (
    <Tooltip content={translate(ACTIVATION_SETTINGS_TOOLTIP)}>
        <SC.Wrapper>
            <IconButton
                iconName="settings"
                iconSize="sm"
                type="flat"
                onClick={onClick}
                dataAutomation={headerDataAutomation.settingsButton}
            />
        </SC.Wrapper>
    </Tooltip>
));

SettingsIcon.displayName = "SettingsIcon";
